import Reveal from '../../../shared/Reveal/Reveal';
import { useVpsHostingAccessControlContent } from '../../../../hooks/useVpsHostingAccessControlContent';
import accessImage from '../../../../assets/images/vpshosting/accessControl/main.jpg';
import infoIcon from '../../../../assets/images/vpshosting/accessControl/Info.svg';
import './AccessControl.css';

const AccessControl = () => {
  const { content, isLoading } = useVpsHostingAccessControlContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, text, note, image, noteIcon } = content;

  return (
    <section className="vps-hosting-access-control">
      <div className="vps-hosting-access-control__inner">
        <Reveal className="vps-hosting-access-control__copy">
          <h2 className="vps-hosting-access-control__title">{title}</h2>
          {text ? <p className="vps-hosting-access-control__text">{text}</p> : null}
          {note ? (
            <div className="vps-hosting-access-control__note">
              <img
                className="vps-hosting-access-control__note-icon"
                src={noteIcon || infoIcon}
                alt=""
                aria-hidden="true"
              />
              <p className="vps-hosting-access-control__note-text">{note}</p>
            </div>
          ) : null}
        </Reveal>
      </div>

      <Reveal className="vps-hosting-access-control__media" delay={80}>
        <img
          className="vps-hosting-access-control__image"
          src={image || accessImage}
          alt=""
          aria-hidden="true"
        />
      </Reveal>
    </section>
  );
};

export default AccessControl;
